import React from "react";
import StatusChip from "../../../common/statusChip/StatusChip";

export function CommentStatusChip({ status }) {
  return <StatusChip value={status} />;
}
